function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamPulse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "18px",
    height: "19px",
    viewBox: "0 0 18 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#535B66",
      fillOpacity: 1
    },
    d: "M 6.910156 1.25 C 4.5625 1.828125 2.410156 3.691406 1.445312 6 C 0.546875 8.152344 0.675781 8.34375 3.246094 8.34375 L 5.496094 8.34375 L 6.363281 10.269531 L 7.265625 12.195312 L 8.195312 8.570312 C 8.679688 6.613281 9.226562 4.492188 9.386719 3.914062 C 9.867188 2.214844 10.480469 2.695312 11.441406 5.519531 L 12.375 8.183594 L 14.5625 8.28125 C 17.101562 8.375 17.164062 8.214844 15.941406 5.585938 C 14.367188 2.246094 10.511719 0.386719 6.910156 1.25 Z M 6.910156 1.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#535B66",
      fillOpacity: 1
    },
    d: "M 8.96875 9.53125 C 8.355469 11.9375 7.648438 13.992188 7.457031 14.058594 C 7.199219 14.121094 6.652344 13.253906 6.042969 11.90625 L 5.015625 9.628906 L 0.898438 9.628906 L 1.09375 10.625 C 1.640625 13.382812 3.792969 15.726562 6.558594 16.527344 C 8.550781 17.136719 9.128906 17.136719 11.121094 16.527344 C 13.242188 15.917969 15.011719 14.378906 15.941406 12.386719 C 17.164062 9.757812 17.101562 9.660156 14.238281 9.5625 L 11.796875 9.46875 L 11.023438 7.382812 C 10.574219 6.226562 10.222656 5.261719 10.1875 5.230469 C 10.125 5.199219 9.609375 7.15625 8.96875 9.53125 Z M 8.96875 9.53125 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamPulse);
export default __webpack_public_path__ + "static/media/teamPulse.e0293a09b9f71244f142595bd16b7499.svg";
export { ForwardRef as ReactComponent };